import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { Typography } from '@mui/material';
import '../../Styles/login.scss';
import FilledLogo from '../../Components/Logos/FilledLogo';
import CustomButton from '../../Components/Inputs/CustomButton';
import OtpField from '../../Components/Inputs/OtpField';

const Verify2FAPage = function Verify2FAPage({ onSubmit }) {
  const intl = useIntl();
  const methods = useForm();
  const { username, password } = useLocation()?.state || {};
  const [otpCode, setOtpCode] = useState('');
  const [line1, line2] =
    typeof intl.messages.SLOGAN === 'undefined'
      ? ['', '']
      : intl.messages.SLOGAN.split(',');

  const onOtpCodeSubmit = () => onSubmit({ otpCode, username, password });
  return (
    <div
      className="login"
      style={{ display: 'flex', width: '100%', height: '100%' }}
    >
      <div className="left" style={{ width: '50%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '17% 12%',
            height: '100%',
            width: '100%',
          }}
        >
          <FilledLogo width="600px" height="160px" />
          <Typography
            sx={{
              color: 'white.main',
              mt: '6%',
              fontWeight: 400,

              fontSize: '3rem',
            }}
            noWrap
          >
            {line1},
          </Typography>
          <Typography
            sx={{
              color: 'white.main',
              fontWeight: 400,
              textAlign: 'end',
              overflow: 'visible',

              fontSize: '3rem',
            }}
            noWrap
          >
            {line2}
          </Typography>
        </div>
      </div>
      <div className="right" style={{ width: '50%' }}>
        <div
          style={{
            width: '70%',
            padding: '8% 16%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '10%',
          }}
        >
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onOtpCodeSubmit)}>
              <Typography variant="h4" sx={{ color: 'greys.title' }}>
                {intl.messages.OTP_VERIFICATION}
              </Typography>
              <OtpField
                value={otpCode}
                onChange={(value) => setOtpCode(value)}
                length={6}
                fontSize="1.5rem"
              />
              <CustomButton
                type="submit"
                styles={{
                  width: '100%',
                  mb: '24px',
                  height: '50px',
                  mt: '8px',
                }}
                disabled={otpCode.length < 6}
                label={intl.messages.CONFIRM}
              />
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

Verify2FAPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default Verify2FAPage;
